import React from "react";

import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import IntlMessages from "../../helpers/IntlMessages";

const Alert = ({ modal, toggle, deleteItem }) => (
  <>
    <Modal isOpen={modal} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        <IntlMessages id="modal.modal-title" />
      </ModalHeader>
      <ModalBody>آیا از حذف این مورد اطمینان دارید؟</ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={deleteItem}>
          بله
        </Button>
        <Button color="secondary" onClick={toggle}>
          خیر
        </Button>
      </ModalFooter>
    </Modal>
  </>
);
export default Alert;
